import { Injectable } from "@angular/core";
import { BillingDto } from "@app/modules/shared/model/billing/billing.dto";
import { BillingCalculationDto } from "@app/modules/shared/model/billing/calculate/billing-calculation.dto";
import { UtilService } from "@app/modules/shared/services/util.service";
import { BillingLineDto } from "@app/modules/shared/model/billing/billing-line.dto";
import { BillingCalculationDiscountDto } from "@app/modules/shared/model/billing/calculate/billing-calculation-discount.dto";
import { BillingCalculationExpenseDto } from "@app/modules/shared/model/billing/calculate/billing-calculation-expense.dto";
import { BillingDiscountDto } from "@app/modules/shared/model/billing/billing-discount.dto";
import { BillingLineDiscountDto } from "@app/modules/shared/model/billing/billing-line-discount.dto";

@Injectable()
export class BillingCalculateService {
  newBilling: BillingDto = new BillingDto();
  purchaseCalculation: BillingCalculationDto = new BillingCalculationDto();

  constructor(private utilService: UtilService) {}

  deductionAmount(vatAmount: number, deduction1: number, deduction2: number) {
    let deductionRate = 0;
    let deductionAmount = 0;
    if (deduction1 > 0 && deduction2 > 0) {
      deductionRate = (deduction1 / deduction2) * 100;
      deductionAmount = (vatAmount / 100) * deductionRate;
    }

    return deductionAmount;
  }

  calculate(billing: BillingDto) {
    this.newBilling.discount_amount = 0;
    this.newBilling.expense_amount = 0;
    this.newBilling.vat_amount = 0;
    this.newBilling.without_vat_amount = 0;
    this.newBilling.net_total_amount = 0;
    this.newBilling.gross_total_amount = 0;
    this.newBilling.discounts = new Array<BillingDiscountDto>();
    this.newBilling.lines = new Array<BillingLineDto>();

    const purchaseCalculation: BillingCalculationDto =
      new BillingCalculationDto();

    billing.lines.forEach((externalBillingLine) => {
      let line_discount_rate = "";
      let line_expense_rate = "";
      let localPrice = 0;
      let billingLine: BillingLineDto = new BillingLineDto();
      let lineCalculationDiscount: BillingCalculationDiscountDto =
        new BillingCalculationDiscountDto();
      let lineCalculationExpense: BillingCalculationExpenseDto =
        new BillingCalculationExpenseDto();
      lineCalculationDiscount.net_unit_amount = 0;
      lineCalculationDiscount.line_amount = 0;
      lineCalculationDiscount.document_amount = 0;
      lineCalculationDiscount.discounts = new Array<BillingDiscountDto>();
      lineCalculationDiscount.lineDiscounts =
        new Array<BillingLineDiscountDto>();
      lineCalculationExpense.net_unit_amount = 0;
      lineCalculationExpense.line_amount = 0;
      lineCalculationExpense.document_amount = 0;
      lineCalculationExpense.vat_amount = 0;
      lineCalculationExpense.temp_vat_amount = 0;
      lineCalculationExpense.expenses = new Array<BillingDiscountDto>();
      lineCalculationExpense.lineExpenses = new Array<BillingLineDiscountDto>();

      billing.discount_amount = 0;
      billing.expense_amount = 0;
      billing.vat_amount = 0;
      billing.without_vat_amount = 0;
      billing.net_total_amount = 0;
      billing.gross_total_amount = 0;

      billingLine = UtilService.deepCopy(externalBillingLine);
      billingLine.document_disc_amount = 0;
      billingLine.document_expense_amount = 0;
      billingLine.vat_amount = 0;
      billingLine.without_vat_amount = 0;
      billingLine.net_total_amount = 0;
      billingLine.gross_total_amount = 0;
      if (billingLine.rec_status === "DELETE") {
        return;
      }

      localPrice = billingLine.price;
      if (billingLine.exchange_rate > 0) {
        localPrice = localPrice * billingLine.exchange_rate;
      }
      // Kdv Hariç ise
      if (billingLine.vat_included === "NO") {
        lineCalculationDiscount.net_unit_amount = localPrice;
      } else {
        // Kdv Dahil ise
        lineCalculationDiscount.net_unit_amount =
          localPrice / (1 + billingLine.vat_rate / 100);
      }
      lineCalculationDiscount.net_unit_amount = UtilService.round(
        lineCalculationDiscount.net_unit_amount,
        5
      );
      lineCalculationExpense.net_unit_amount =
        lineCalculationDiscount.net_unit_amount;

      // İndirimler hesaplanıyor.
      lineCalculationDiscount = this.prepareDiscount(
        lineCalculationDiscount,
        billingLine,
        billing.discounts
      );
      billingLine.discount_amount = lineCalculationDiscount.line_amount;
      lineCalculationExpense.calculationDiscount = lineCalculationDiscount;

      // Masraflar Hesaplanıyor
      lineCalculationExpense = this.prepareExpense(
        lineCalculationExpense,
        billingLine,
        billing.discounts
      );
      billingLine.expense_amount = lineCalculationExpense.line_amount;
      lineCalculationDiscount.document_amount = UtilService.round(
        lineCalculationDiscount.document_amount,
        2
      );
      lineCalculationDiscount.line_amount = UtilService.round(
        lineCalculationDiscount.line_amount,
        2
      );
      lineCalculationExpense.document_amount = UtilService.round(
        lineCalculationExpense.document_amount,
        2
      );
      lineCalculationExpense.line_amount = UtilService.round(
        lineCalculationExpense.line_amount,
        2
      );
      lineCalculationExpense.vat_amount = UtilService.round(
        lineCalculationExpense.vat_amount,
        2
      );

      billingLine.gross_total_amount = UtilService.round(
        billingLine.quantity * localPrice,
        2
      );
      billingLine.without_vat_amount =
        lineCalculationDiscount.net_unit_amount * billingLine.quantity;
      billingLine.vat_amount =
        (billingLine.without_vat_amount / 100) * billingLine.vat_rate;
      billingLine.local_price = UtilService.round(localPrice, 5);
      billingLine.net_price = UtilService.round(
        lineCalculationDiscount.net_unit_amount,
        5
      );
      // Tevkifat hesapla
      if (billingLine.deduction1 != null && billingLine.deduction2 != null) {
        billingLine.deduction_amount = UtilService.round(
          this.deductionAmount(
            billingLine.vat_amount,
            billingLine.deduction1,
            billingLine.deduction2
          ),
          2
        );
      } else {
        billingLine.deduction_amount = 0;
      }
      billingLine.deduction_amount = UtilService.round(
        billingLine.deduction_amount,
        2
      );
      billingLine.without_vat_amount = UtilService.round(
        billingLine.without_vat_amount,
        2
      );
      billingLine.vat_amount = UtilService.round(billingLine.vat_amount, 2);
      billingLine.without_vat_amount = UtilService.round(
        billingLine.without_vat_amount +
          lineCalculationExpense.line_amount +
          lineCalculationExpense.document_amount,
        2
      );
      billingLine.vat_amount = UtilService.round(
        billingLine.vat_amount +
          lineCalculationExpense.vat_amount -
          billingLine.deduction_amount,
        2
      );
      billingLine.net_total_amount = UtilService.round(
        billingLine.vat_amount + billingLine.without_vat_amount,
        2
      );
      billingLine.gross_total_amount = UtilService.round(
        billingLine.gross_total_amount,
        2
      );
      billingLine.discounts = new Array<BillingLineDiscountDto>();

      // Belge altı indirimler objeye set ediliyor
      lineCalculationDiscount.discounts.forEach((discount) => {
        let foundDiscount = new BillingDiscountDto();
        foundDiscount = this.newBilling.discounts.find(
          (_discount) =>
            _discount.line_type === discount.line_type &&
            _discount.external_id !== null &&
            _discount.external_id === discount.external_id
        );
        if (foundDiscount) {
          foundDiscount.amount = foundDiscount.amount + discount.amount;
        } else {
          this.newBilling.discounts.push(discount);
        }
      });

      // Satir İndirimleri objeye set ediliyor
      lineCalculationDiscount.lineDiscounts.forEach((discount) => {
        line_discount_rate = line_discount_rate + discount.rate + "+";
        billingLine.discounts.push(discount);
      });

      // Satır indirimleri hesaplandıktan sonra oranlar tekrardan birleşlitirilerek billingLine.discount_rate değerine yeniden set ediliyor
      if (line_discount_rate.length > 0) {
        line_discount_rate = line_discount_rate.substring(
          0,
          line_discount_rate.length - 1
        );
        billingLine.discount_rate = line_discount_rate;
      }

      // Belge altı masrafları objeye set ediliyor
      lineCalculationExpense.expenses.forEach((expense) => {
        let foundDiscount = new BillingDiscountDto();
        foundDiscount = this.newBilling.discounts.find(
          (_discount) =>
            _discount.line_type === expense.line_type &&
            _discount.external_id !== null &&
            _discount.external_id === expense.external_id
        );
        if (foundDiscount) {
          foundDiscount.amount = foundDiscount.amount + expense.amount;
        } else {
          this.newBilling.discounts.push(expense);
        }
      });

      // Satir Masrafları objeye set ediliyor
      lineCalculationExpense.lineExpenses.forEach((expense) => {
        line_expense_rate = line_expense_rate + expense.rate + "+";
        billingLine.discounts.push(expense);
      });

      // Satır masrafları hesaplandıktan sonra oranlar tekrardan birleşlitirilerek billingLine.expense_rate değerine yeniden set ediliyor
      if (line_expense_rate.length > 0) {
        line_expense_rate = line_expense_rate.substring(
          0,
          line_expense_rate.length - 1
        );
        billingLine.expense_rate = line_expense_rate;
      }

      this.newBilling.lines.push(billingLine);
      if (billingLine.document_disc_amount != null) {
        this.newBilling.discount_amount = UtilService.round(
          this.newBilling.discount_amount +
            billingLine.document_disc_amount +
            billingLine.discount_amount,
          2
        );
      }
      if (billingLine.document_expense_amount != null) {
        this.newBilling.expense_amount = UtilService.round(
          this.newBilling.expense_amount +
            billingLine.document_expense_amount +
            billingLine.expense_amount,
          2
        );
      }
      if (billingLine.vat_amount != null) {
        this.newBilling.vat_amount = UtilService.round(
          this.newBilling.vat_amount + billingLine.vat_amount,
          2
        );
      }
      if (billingLine.without_vat_amount != null) {
        this.newBilling.without_vat_amount = UtilService.round(
          this.newBilling.without_vat_amount + billingLine.without_vat_amount,
          2
        );
      }
      if (billingLine.net_total_amount != null) {
        this.newBilling.net_total_amount = UtilService.round(
          this.newBilling.net_total_amount + billingLine.net_total_amount,
          2
        );
      }
      if (billingLine.gross_total_amount != null) {
        this.newBilling.gross_total_amount = UtilService.round(
          this.newBilling.gross_total_amount + billingLine.gross_total_amount,
          2
        );
      }
    });

    purchaseCalculation.billing = this.newBilling;
    return purchaseCalculation;
  }

  /* İndirimleri hesapla */
  prepareDiscount(
    calculationDiscount: BillingCalculationDiscountDto,
    billingLine: BillingLineDto,
    discounts: Array<BillingDiscountDto>
  ) {
    let rates = [];
    rates = billingLine.discount_rate.split("+", 20);
    /* SATIR İNDİRİMLER HESAPLANIYOR */

    // Hesaplama oran üzerinden yapılacak ise
    if (billingLine.calculation_type === "RATE") {
      rates.forEach((rate) => {
        let discountRate = 0;
        let tempDiscountAmount = 0;
        if (rate > 0) {
          if (rate > 100) {
            discountRate = 100;
          } else {
            discountRate = rate;
          }

          tempDiscountAmount =
            (calculationDiscount.net_unit_amount / 100) *
            discountRate *
            billingLine.quantity;
          calculationDiscount.net_unit_amount =
            calculationDiscount.net_unit_amount -
            (calculationDiscount.net_unit_amount / 100) * discountRate;
          calculationDiscount.line_amount =
            calculationDiscount.line_amount + tempDiscountAmount;
          // Hesaplanan satır indirimini nesneye ekle
          const billingLineDiscount: BillingLineDiscountDto =
            new BillingLineDiscountDto();
          billingLineDiscount.external_id = billingLine.external_id;
          billingLineDiscount.discount_line_type = "DISCOUNT";
          billingLineDiscount.rate = UtilService.round(discountRate, 2);
          billingLineDiscount.amount = UtilService.round(tempDiscountAmount, 2);
          calculationDiscount.lineDiscounts.push(billingLineDiscount);
        }
      });
    } else if (billingLine.calculation_type === "AMOUNT") {
      // Hesaplama tutar üzerinden yapılacak ise
      let discountRate = 0;
      let tempDiscountAmount = 0;
      if (billingLine.discount_amount > 0) {
        discountRate =
          (billingLine.discount_amount /
            (calculationDiscount.net_unit_amount * billingLine.quantity)) *
          100;
        billingLine.discount_rate = UtilService.round(
          discountRate,
          5
        ).toString();
        tempDiscountAmount =
          (calculationDiscount.net_unit_amount / 100) *
          discountRate *
          billingLine.quantity;
        calculationDiscount.net_unit_amount =
          calculationDiscount.net_unit_amount -
          (calculationDiscount.net_unit_amount / 100) * discountRate;
        calculationDiscount.line_amount =
          calculationDiscount.line_amount + tempDiscountAmount;
        // Hesaplanan satır indirimini nesneye ekle
        const billingLineDiscount: BillingLineDiscountDto =
          new BillingLineDiscountDto();
        billingLineDiscount.external_id = billingLine.external_id;
        billingLineDiscount.discount_line_type = "DISCOUNT";
        billingLineDiscount.rate = UtilService.round(discountRate, 2);
        billingLineDiscount.amount = UtilService.round(tempDiscountAmount, 2);
        calculationDiscount.lineDiscounts.push(billingLineDiscount);
      }
    }
    calculationDiscount.line_amount = UtilService.round(
      calculationDiscount.line_amount,
      2
    );

    /* BELGE ALTI İNDİRİMLER HESAPLANIYOR */
    if (discounts.length > 0) {
      discounts.forEach((discount) => {
        if (discount.line_type === "DISCOUNT") {
          let tempDiscountAmount = 0;
          let discountRate = 0;
          if (discount.rec_status === "DELETE") {
            return;
          }
          // Oran üzerinden hesaplansın ise
          if (discount.calculation_type === "RATE" && discount.rate > 0) {
            if (discount.rate > 100) {
              discountRate = 100;
            } else {
              discountRate = discount.rate;
            }

            tempDiscountAmount =
              (calculationDiscount.net_unit_amount / 100) *
              discountRate *
              billingLine.quantity;
            calculationDiscount.net_unit_amount =
              calculationDiscount.net_unit_amount -
              (calculationDiscount.net_unit_amount / 100) * discountRate;
            calculationDiscount.document_amount =
              calculationDiscount.document_amount + tempDiscountAmount;
          } else if (
            discount.calculation_type === "AMOUNT" &&
            discount.amount > 0
          ) {
            discountRate =
              (discount.amount /
                (calculationDiscount.net_unit_amount * billingLine.quantity)) *
              100;

            // Frondend'den gelen Belge altı indirim tutarı belge toplamından büyük olduğu zaman hesaplama karışıyoyor o yüzden orana 100 değeri set ediliyor
            if (discountRate > 100) {
              discountRate = 100;
            }
            tempDiscountAmount =
              (calculationDiscount.net_unit_amount / 100) *
              discountRate *
              billingLine.quantity;
            calculationDiscount.net_unit_amount =
              calculationDiscount.net_unit_amount -
              (calculationDiscount.net_unit_amount / 100) * discountRate;
            calculationDiscount.document_amount =
              calculationDiscount.document_amount + tempDiscountAmount;
          }

          // Hesaplanan Belge indirimini belge nesnesine ekle
          const billingDiscount: BillingDiscountDto = new BillingDiscountDto();
          billingDiscount.external_id = discount.external_id;
          billingDiscount.calculation_type = discount.calculation_type;
          billingDiscount.line_type = discount.line_type;
          billingDiscount.exchange_rate = discount.exchange_rate;
          billingDiscount.rate = UtilService.round(discountRate, 2);
          billingDiscount.amount = UtilService.round(tempDiscountAmount, 2);
          calculationDiscount.discounts.push(billingDiscount);
          if (billingLine.document_disc_amount === null) {
            billingLine.document_disc_amount = 0;
          }
          billingLine.document_disc_amount =
            billingLine.document_disc_amount + billingDiscount.amount;
        }
      });
    }

    return calculationDiscount;
  }

  /* Masrafları hesapla */
  prepareExpense(
    calculationExpense: BillingCalculationExpenseDto,
    billingLine: BillingLineDto,
    discounts: Array<BillingDiscountDto>
  ) {
    let rates = [];
    rates = billingLine.expense_rate.split("+", 20);
    /* SATIR MASRAFLARI HESAPLANIYOR */

    // Hesaplama oran üzerinden yapılacak ise
    if (billingLine.calculation_type === "RATE") {
      rates.forEach((rate) => {
        let expenseRate = 0;
        let tempExpenseAmount = 0;

        expenseRate = rate;

        if (expenseRate > 0) {
          // İndirim düşülmeden önce hesaplansın ise
          if (billingLine.expense_rate_type === "BEFORE_DISCOUNT") {
            tempExpenseAmount =
              (calculationExpense.net_unit_amount / 100) *
              expenseRate *
              billingLine.quantity;
          } else if (billingLine.expense_rate_type === "AFTER_DISCOUNT") {
            tempExpenseAmount =
              (calculationExpense.calculationDiscount.net_unit_amount / 100) *
              expenseRate *
              billingLine.quantity;
          }
          tempExpenseAmount = UtilService.round(tempExpenseAmount, 2);
          calculationExpense.vat_amount =
            calculationExpense.vat_amount +
            (tempExpenseAmount / 100) * billingLine.vat_rate;
          calculationExpense.vat_amount = UtilService.round(
            calculationExpense.vat_amount,
            2
          );
          calculationExpense.line_amount =
            calculationExpense.line_amount + tempExpenseAmount;
          // Hesaplanan satır masrafını nesneye ekle
          const billingLineDiscount: BillingLineDiscountDto =
            new BillingLineDiscountDto();
          billingLineDiscount.external_id = billingLine.external_id;
          billingLineDiscount.discount_line_type = "EXPENSE";
          billingLineDiscount.rate = UtilService.round(expenseRate, 2);
          billingLineDiscount.amount = UtilService.round(tempExpenseAmount, 2);
          calculationExpense.lineExpenses.push(billingLineDiscount);
        }
      });
    } else if (billingLine.calculation_type === "AMOUNT") {
      // Hesaplama tutar üzerinden yapılacak ise
      let expenseRate = 0;
      let tempExpenseAmount = 0;
      // İndirim düşülmeden ÖNCE hesaplansın ise
      if (billingLine.expense_rate_type === "BEFORE_DISCOUNT") {
        expenseRate =
          (billingLine.expense_amount /
            (calculationExpense.net_unit_amount * billingLine.quantity)) *
          100;
        billingLine.expense_rate = UtilService.round(expenseRate, 5).toString();
        tempExpenseAmount =
          (calculationExpense.net_unit_amount / 100) *
          expenseRate *
          billingLine.quantity;
        tempExpenseAmount = UtilService.round(tempExpenseAmount, 2);
      }

      // İndirim düşüldükten SONRA hesaplansın ise
      if (billingLine.expense_rate_type === "AFTER_DISCOUNT") {
        expenseRate =
          (billingLine.expense_amount /
            (calculationExpense.calculationDiscount.net_unit_amount *
              billingLine.quantity)) *
          100;
        tempExpenseAmount =
          (calculationExpense.calculationDiscount.net_unit_amount / 100) *
          expenseRate *
          billingLine.quantity;
        tempExpenseAmount = UtilService.round(tempExpenseAmount, 2);
      }
      calculationExpense.vat_amount =
        calculationExpense.vat_amount +
        (tempExpenseAmount / 100) * billingLine.vat_rate;
      calculationExpense.vat_amount = UtilService.round(
        calculationExpense.vat_amount,
        2
      );
      calculationExpense.line_amount =
        calculationExpense.line_amount + tempExpenseAmount;
      // Hesaplanan satır masrafları nesneye ekle
      const billingLineDiscount: BillingLineDiscountDto =
        new BillingLineDiscountDto();
      billingLineDiscount.external_id = billingLine.external_id;
      billingLineDiscount.discount_line_type = "EXPENSE";
      billingLineDiscount.rate = UtilService.round(expenseRate, 2);
      billingLineDiscount.amount = UtilService.round(tempExpenseAmount, 2);
      calculationExpense.lineExpenses.push(billingLineDiscount);
    }

    /* BELGE ALTI MASRAFLAR HESAPLANIYOR */
    if (discounts.length > 0) {
      discounts.forEach((discount) => {
        if (discount.line_type === "EXPENSE") {
          let tempExpenseAmount = 0;
          let tempExpenseVatAmount = 0;
          let expenseRate = 0;
          if (discount.rec_status === "DELETE") {
            return;
          }
          // Oran üzerinden hesaplansın ise
          if (discount.calculation_type === "RATE" && discount.rate > 0) {
            if (discount.rate > 100) {
              expenseRate = 100;
            } else {
              expenseRate = discount.rate;
            }

            // İndirim düşülmeden ÖNCE hesaplansın ise
            if (billingLine.expense_rate_type === "BEFORE_DISCOUNT") {
              tempExpenseAmount =
                (calculationExpense.net_unit_amount / 100) *
                expenseRate *
                billingLine.quantity;
              tempExpenseAmount = UtilService.round(tempExpenseAmount, 2);
            }
            // İndirim düşüldükten SONRA hesaplansın ise
            if (billingLine.expense_rate_type === "AFTER_DISCOUNT") {
              tempExpenseAmount =
                (calculationExpense.calculationDiscount.net_unit_amount / 100) *
                expenseRate *
                billingLine.quantity;
              tempExpenseAmount = UtilService.round(tempExpenseAmount, 2);
            }
            tempExpenseVatAmount =
              (tempExpenseAmount / 100) * billingLine.vat_rate;
            tempExpenseVatAmount = UtilService.round(tempExpenseVatAmount, 2);
          }
          // Tutar üzerinden hesaplansın ise
          if (discount.calculation_type === "AMOUNT" && discount.amount > 0) {
            // İndirim düşülmeden ÖNCE hesaplansın ise
            if (billingLine.expense_rate_type === "BEFORE_DISCOUNT") {
              expenseRate =
                (discount.amount /
                  (calculationExpense.net_unit_amount * billingLine.quantity)) *
                100;
              tempExpenseAmount =
                (calculationExpense.net_unit_amount / 100) *
                expenseRate *
                billingLine.quantity;
              tempExpenseAmount = UtilService.round(tempExpenseAmount, 2);
              calculationExpense.vat_amount =
                (tempExpenseAmount / 100) * billingLine.vat_rate;
              calculationExpense.vat_amount = UtilService.round(
                calculationExpense.vat_amount,
                2
              );
            }
            // İndirim düşüldükten SONRA hesaplansın ise
            if (billingLine.expense_rate_type === "AFTER_DISCOUNT") {
              expenseRate =
                (discount.amount /
                  (calculationExpense.calculationDiscount.net_unit_amount *
                    billingLine.quantity)) *
                100;
              tempExpenseAmount =
                (calculationExpense.calculationDiscount.net_unit_amount / 100) *
                expenseRate *
                billingLine.quantity;
              tempExpenseAmount = UtilService.round(tempExpenseAmount, 2);
              calculationExpense.vat_amount =
                (tempExpenseAmount / 100) * billingLine.vat_rate;
              calculationExpense.vat_amount = UtilService.round(
                calculationExpense.vat_amount,
                2
              );
            }
          }
          calculationExpense.document_amount =
            calculationExpense.document_amount + tempExpenseAmount;
          calculationExpense.vat_amount =
            calculationExpense.vat_amount + tempExpenseVatAmount;

          // Hesaplanan belge masrafını nesneye ekle
          const billingDiscount: BillingDiscountDto = new BillingDiscountDto();
          billingDiscount.external_id = discount.external_id;
          billingDiscount.calculation_type = discount.calculation_type;
          billingDiscount.line_type = discount.line_type;
          billingDiscount.exchange_rate = discount.exchange_rate;
          billingDiscount.rate = UtilService.round(expenseRate, 2);
          billingDiscount.amount = UtilService.round(tempExpenseAmount, 2);
          calculationExpense.expenses.push(billingDiscount);
          if (billingLine.document_expense_amount === null) {
            billingLine.document_expense_amount = 0;
          }
          billingLine.document_expense_amount =
            billingLine.document_expense_amount + billingDiscount.amount;
        }
      });
    }
    return calculationExpense;
  }
}
